export enum ShippingStatusType {
  open = 'OPEN',
  readyForShipping = 'READY',
  fulfilled = 'FULFILLED',
}
